module.exports = __webpack_public_path__ + "static/media/backsplash2_lowres.fb2813b8.jpg";